<template>
  <div id="unactive_screen" class="vi-paywall">
    <div
      class="vi-paywall__bg"
      :style="bgImage ? 'background-image:url(' + bgImage + ')' : ''"
      aria-hidden="true"
    ></div>
    <div class="vi-paywall__veil" aria-hidden="true"></div>
   
    <div class="vi-paywall__inner">
      <!-- Back navigation -->
      <router-link to="/" class="vi-paywall__back" aria-label="חזור לדף הבית">
        <!-- right-pointing chevron (RTL: visual back = right side) -->
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"
             class="vi-paywall__back-icon">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </router-link>

      <!-- Upsell banner -->
      <div class="vi-paywall__banner" role="status">
        <p class="vi-paywall__headline">תוכן זה זמין למשתמשים רשומים בלבד</p>
        <p class="vi-paywall__sub">רוצים לצפות בכל התכנים של TOV+ ?</p>
      </div>

      <!-- Primary CTA 
      <UiButton
        v-if="!isUserLogin"
        variant="primary"
        size="lg"
        :block="true"
        class="vi-paywall__cta"
        @click="$emit('signup')"
      >
        הרשמו עכשיו!
      </UiButton>-->

      <a
        v-if="isUserLogin"
        :href="renewUrl"
        class="vi-paywall__cta-link"
      >
        <UiButton variant="primary" size="lg" :block="true">חדש מנוי עכשיו</UiButton>
      </a>

      <!-- Accordion: upsell reasons -->
      <div class="vi-paywall__accordion">
        <div
          v-for="(panel, index) in panels"
          :key="index"
          class="vi-paywall__panel"
        >
          <button
            type="button"
            class="vi-paywall__panel-toggle"
            :aria-expanded="panel.open ? 'true' : 'false'"
            :aria-controls="'vi-panel-' + index"
            @click="togglePanel(index)"
          >
            <span>{{ panel.title }}</span>
            <svg
              class="vi-paywall__chevron"
              :class="{ 'vi-paywall__chevron--open': panel.open }"
              width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true"
            >
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>
          <div
            :id="'vi-panel-' + index"
            v-show="panel.open"
            class="vi-paywall__panel-body"
          >
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="panel.content"></p>
          </div>
        </div>

        <div class="vi-paywall__closing">
          <p>העלו אתנו על נס את טובת עם ישראל, מדינת ישראל ותורת ישראל מעל לכל. רק דיבור יהודי אינטלקטואלי צלול וברור, שלא חושש להגיד את האמת, יכול להביא את השינוי.</p>
        </div>

        <!-- Bottom CTA (repeated after accordion) -->
        <UiButton
          v-if="!isUserLogin"
          variant="primary"
          size="lg"
          :block="true"
          class="vi-paywall__cta"
          @click="$emit('signup')"
        >
          הרשמו עכשיו!
        </UiButton>
        <a
          v-if="isUserLogin"
          :href="renewUrl"
          class="vi-paywall__cta-link"
        >
          <UiButton variant="primary" size="lg" :block="true">חדש מנוי עכשיו</UiButton>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from '../ui/Button.vue';

const PANELS = [
  {
    title: 'אקטואליה יהודית עולה קומה עם ערוץ הסדרות TOV+',
    content: 'כל התוכן הכי חזק שלנו ארוז ומונגש, עם מנוע חיפוש מתקדם לפי מומחים ותחומי עניין. יצירת אזור תוכן בהתאמה אישית לחווית צפייה שעוד לא פגשתם. הצטרפו אלינו ותהיו מאלה שיודעים!',
    open: true,
  },
  {
    title: 'מה תקבלו ב TOV+?',
    content: 'בכל חודש עשרות ראיונות וסדרות עומק נוקבות עם מיטב המומחים בביטחון, משפט, כלכלה, חברה, יהדות ועוד. כוכבי הערוץ: מוטי קידר, האלוף יצחק בריק, אליהו יוסיאן, אילן ציאון, סמדר הילה שמואלי, האלוף גרשון הכהן, דוד פסיג, קרוליין גליק, גדי טאוב, חיים רמון אלדד יניב עו"ד יורם שפטל ועוד רבים וטובים. האמת כולה בלי צנזורה ובלי כפפות.',
    open: false,
  },
  {
    title: 'למה להצטרף אם יש את ערוץ TOV בחינם ביוטיוב?',
    content: '<strong>כי</strong> ב TOV+ תקבלו תוכן פרימיום מקורי שלא תמצאו בשום מקום אחר!<br><strong>כי</strong> מובטחת לכם חווית צפייה שעוד לא פגשתם.<br><strong>כי</strong> ככה תהיו שותפים בהחזקת ערוץ תקשורת עצמאי, נושך שלא מקבל תקציב מאף גורם.<br><strong>כי</strong> בלעדיכם זה לא יכול לקרות.',
    open: false,
  },
  {
    title: 'איך מצטרפים?',
    content: 'בקלות. נרשמים. משקיעים בנו כל סכום שתבחרו בו לפי יכולתכם, הערכתכם ורצונכם ה TOV - כדי לתמוך בנו! ואתם מחוברים.',
    open: false,
  },
];

export default {
  name: 'VideoInfoPaywall',
  components: { UiButton },
  props: {
    isUserLogin: { type: Boolean, default: false },
    renewUrl: { type: String, default: '' },
    bgImage: { type: String, default: '' },
  },
  data() {
    return {
      panels: PANELS.map(p => ({ ...p })),
    };
  },
  methods: {
    togglePanel(index) {
      this.panels[index].open = !this.panels[index].open;
    },
  },
};
</script>

<style scoped lang="scss">
.vi-paywall {
  position: relative;
  z-index: 1;
  overflow: hidden;
  min-height: calc(100svh - 68px);
  padding: var(--space-6);
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.vi-paywall__bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(22px) brightness(0.42);
  transform: scale(1.08);
}

.vi-paywall__veil {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 15%, rgba(225, 29, 42, 0.2), transparent 36%),
    linear-gradient(180deg, rgba(7, 8, 12, 0.9) 0%, rgba(7, 8, 12, 0.95) 100%);
}

.vi-paywall__headline {
  margin: 0;
  font-size: clamp(28px, 4.2vw, 44px);
  line-height: 1.18;
  font-weight: var(--weight-semibold, 600);
  color: var(--color-accent);
  text-wrap: balance;
}

.vi-paywall__sub {
  margin: var(--space-3) auto 0;
  max-inline-size: 34ch;
  font-size: clamp(17px, 2.2vw, 24px);
  line-height: 1.45;
  color: var(--color-textMuted);
  text-wrap: balance;
}


.vi-paywall__inner {
  position: relative;
  margin-inline: auto;
  min-height: fit-content;
  width: min(100%, 760px);
  max-inline-size: 760px;
  padding: var(--space-8) var(--space-7);
  margin-block-start: 0;
  text-align: center;
  background: rgba(8, 10, 14, 0.84);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1;
}

.vi-paywall__back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  rotate:180deg;
  position: absolute;
  right:20px;
  top:20px;
  color: var(--color-text);
  border-radius: var(--radius-sm);
  padding: var(--space-1);
  min-inline-size: 44px;
  min-block-size: 44px;
}

.vi-paywall__back:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/* Keep chevron pointing to the visual right in RTL. */
.vi-paywall__back-icon {
  transform: none;
}

[dir="ltr"] .vi-paywall__back-icon {
  transform: scaleX(-1);
}

.vi-paywall__banner {
  margin-block-end: var(--space-6);
}



.vi-paywall__cta {
  margin-block-end: var(--space-6);
}

.vi-paywall__cta-link {
  display: block;
  text-decoration: none;
  margin-block-end: var(--space-6);
}

/* Accordion */
.vi-paywall__accordion {
  text-align: start;
  border-block-start: 1px solid var(--color-border);
  padding-block-start: var(--space-4);
}

.vi-paywall__panel {
  border-block-end: 1px solid var(--color-border);
}

.vi-paywall__panel-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  inline-size: 100%;
  padding-block: var(--space-4);
  padding-inline: 0;
  background: transparent;
  border: none;
  color: var(--color-text);
  font-size: var(--text-base, 16px);
  font-weight: var(--weight-semibold, 600);
  cursor: pointer;
  text-align: start;
  font-family: var(--font-hebrew);
}

.vi-paywall__panel-toggle:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.vi-paywall__chevron {
  flex-shrink: 0;
  transition: transform var(--duration-base) var(--easing-default);
}

.vi-paywall__chevron--open {
  transform: rotate(180deg);
}

.vi-paywall__panel-body {
  padding-block-end: var(--space-4);
  color: var(--color-textMuted);
  font-size: var(--text-base, 15px);
  line-height: 1.6;
}

.vi-paywall__panel-body p {
  margin: 0;
}

.vi-paywall__closing {
  padding-block: var(--space-4);
  color: var(--color-textMuted);
  font-size: var(--text-base, 16px);
  line-height: 1.6;
}

@media (prefers-reduced-motion: reduce) {
  .vi-paywall__chevron { transition: none; }
}

@media (max-width: 640px) {
  .vi-paywall {
    min-height: calc(100svh - 56px);
    padding:
      calc(env(safe-area-inset-top, 0px) + 12px)
      10px
      calc(env(safe-area-inset-bottom, 0px) + 14px);
  }

  .vi-paywall__inner {
    width: 100%;
    min-height: calc(100svh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px) - 86px);
    padding: 18px 12px 14px;
    border-radius: 14px;
  }

  .vi-paywall__headline {
    font-size: clamp(30px, 9.5vw, 38px);
    line-height: 1.15;
  }

  .vi-paywall__sub {
    font-size: 16px;
    line-height: 1.45;
  }

  .vi-paywall__panel-toggle {
    font-size: 15px;
    line-height: 1.4;
  }

  .vi-paywall__panel-body {
    font-size: 14px;
    line-height: 1.55;
  }

  .vi-paywall__closing {
    font-size: 14px;
    line-height: 1.55;
  }
}
</style>
